import styled from '@emotion/styled';
import { SurveyItem } from 'common/apiService/types/publicApiTypes';
import { Card, CardBody, Link, Icon } from '../../styles';
import React from 'react';
import { useRouter } from 'next/router';
import IconPlayTransparent from '../../icons/IconPlayTransparent';

import getConfig from 'next/config';

// eslint-disable-next-line no-undef
const {  publicRuntimeConfig } = getConfig();

const VideoThumbBody = styled(CardBody)(({ theme }) => ({
  opacity: 1,
  backgroundColor: 'transparent',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  fontSize: '3rem',
  [theme.breakpoints.up('md')]: {
    fontSize: '4rem',
  },
}));
const BASE_URL = publicRuntimeConfig.NEXT_PUBLIC_PLAYER_BASE_URL;

// const BASE_URL = process.env.NEXT_PUBLIC_PLAYER_BASE_URL;

export default function VideoThumb({ image_path, video_file_reference_id: id, player_url, title }: SurveyItem) {
  const { asPath: returnUrl, push } = useRouter();
  const url = `${BASE_URL}/${player_url?.replace('/player', '')}?b=${returnUrl}`;

  const handleClick: React.MouseEventHandler<HTMLDivElement | HTMLAnchorElement> = (e) => {
    e.preventDefault();
    push(url);
  };

  return (
    <Card
      orientation="horizontal"
      style={{ backgroundImage: image_path && `url(${image_path}?w=500)`, minWidth: 0 }}
      as={id ? Link : 'div'}
      href="#"
      onClick={handleClick}
      block
    >
      <VideoThumbBody>
        <Icon><IconPlayTransparent /></Icon>
      </VideoThumbBody>
    </Card>
  );
}
